import axios from 'axios'
import { getToken, getUserId } from '@/util/auth'
import { getLang } from '@/util/lang'
import i18n from '@/i18n'
import { Dialog, Toast } from 'vant'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config.headers['X-SP-Token'] = getToken()
    config.headers['X-SP-UserId'] = getUserId()
    config.headers['X-SP-Lang'] = getLang()
    config.headers['X-SP-Key'] = process.env.VUE_APP_API_KEY
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 1000, it is judged as an error.
    if (res.code !== 1000) {
      // 4000: 权限错误;
      if (res.code === 4000) {
        // to re-login
        Dialog.alert({
          title: i18n.t('account.loginTip'),
          confirmButtonText: i18n.t('common.confirm'),
        }).then(() => {
          router.push('/account/login')
        })
      } else {
        Toast.fail(res.msg)
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
